<template>
  <div class="container">
    <h1 class="title">Iframe Testing</h1>

    <!-- Configuration Panel -->
    <div v-if="!showIframe" class="config-panel">
      <label for="url">Iframe URL: (make sure "https://" is included)</label>
      <input type="text" id="url" v-model="iframeConfig.src" placeholder="Enter iframe URL" />
      <label for="width">Iframe Width:</label>
      <input type="number" id="width" v-model="iframeConfig.width" placeholder="Enter iframe width" />
      <label for="height">Iframe Height:</label>
      <input type="number" id="height" v-model="iframeConfig.height" placeholder="Enter iframe height" />
      <button @click="showIframePanel">Show Iframe</button>
    </div>

    <div v-if="showIframe" class="iframe-container">
      <button class="close-btn" @click="closeIframe">X</button>
      <iframe
          :src="iframeConfig.src"
          :width="iframeConfig.width"
          :height="iframeConfig.height"
          title="Iframe"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showIframe: false,
      iframeConfig: {
        src: "",
        width: 600,
        height: 400,
      },
    };
  },
  methods: {
    // Show iframe with the current configuration
    showIframePanel() {
      this.showIframe = true;
    },

    // Close the iframe and show the configuration panel again
    closeIframe() {
      this.showIframe = false;
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 20px;
}

.title {
  margin-bottom: 20px;
}

.config-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 400px;
}

.iframe-container {
  position: relative;
}

input {
  padding: 8px;
  font-size: 14px;
}

button {
  padding: 10px;
  background-color: #2eb495;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

button:hover {
  opacity: 0.7
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #F15B47;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 16px;
}

.close-btn:hover {
  background-color: #ff1a1a;
}

@media (max-width: 600px) {
  .config-panel {
    max-width: 100%;
  }

  .iframe-container iframe {
    width: 100%;
  }
}
</style>
